import { ShieldAlert } from "lucide-react";

export const SECURITY_REMINDER_TEXT =
  "Although we do everything we can to help keep your information secure, we strongly recommend changing the location of any spare key or updating your lockbox code whenever you begin using a new cleaner. This helps minimise risk and ensures only your current trusted cleaner has access to your property.";

export default function SecurityReminder({ className = "" }) {
  return (
    <div className={`flex gap-3 p-4 rounded-xl bg-amber-50 border border-amber-200 text-amber-900 ${className}`} data-testid="security-reminder">
      <ShieldAlert className="h-5 w-5 shrink-0 mt-0.5" />
      <div>
        <p className="font-semibold text-sm">Security Reminder</p>
        <p className="text-sm mt-1 leading-relaxed">{SECURITY_REMINDER_TEXT}</p>
      </div>
    </div>
  );
}
